var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashBinMinimalistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34766 2.33366C5.58789 1.65396 6.23612 1.16699 6.99808 1.16699C7.76004 1.16699 8.40826 1.65396 8.6485 2.33366",
    stroke: "#808086",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9597 3.5H2.04297",
    stroke: "#808086",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9878 4.95801L10.7195 8.98249C10.6163 10.5312 10.5647 11.3055 10.0601 11.7776C9.5555 12.2497 8.77943 12.2497 7.2273 12.2497H6.77617C5.22404 12.2497 4.44797 12.2497 3.94338 11.7776C3.43879 11.3055 3.38717 10.5312 3.28392 8.98249L3.01562 4.95801",
    stroke: "#808086",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54297 6.41699L5.83464 9.33366",
    stroke: "#808086",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45964 6.41699L8.16797 9.33366",
    stroke: "#808086",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBinMinimalistic);
export default __webpack_public_path__ + "static/media/TrashBinMinimalistic.8b136fe8e84c35d9456722e6c876e56a.svg";
export { ForwardRef as ReactComponent };